<div class="flex flex-col items-center gap-2.5" *transloco="let t; read: 'legalLinks'">
  <div class="flex gap-6">
    <a [href]="legalLinks.imprint" target="_blank" rel="noopener noreferrer" class="!text-small-bold text-gray-500 hover:text-gray-400">{{
      t('imprint')
    }}</a>
    <a
      [href]="legalLinks.privacyPolicy"
      target="_blank"
      rel="noopener noreferrer"
      class="!text-small-bold text-gray-500 hover:text-gray-400"
      >{{ t('privacyPolicy') }}</a
    >
  </div>
  <p class="text-gray-500">{{ t('legalNotice') }}</p>
</div>
